"use strict"

import React, { useEffect, useState } from "react"
import { FormattedMessage } from "react-intl"

import { API_STATUS } from "../../../shared_components/widgets/utils"
import PageLoadingPanel from "../../../shared_components/widgets/PageLoadingPanel"
import PageErrorPanel from "../../../shared_components/widgets/PageErrorPanel"
import { LanzaTable, UniversalFilter } from "../../../shared_components/widgets/LanzaTable"
import { LocaleFormattedDate } from "../../internationalization/LocaleFormatted"
import { withInventoryConfig } from "../../../config/InventoryConfigProvider"

function InventoryItemsTable({
  setAvailableItems,
  inventoryTypes = [],
  inventoryItems = [],
  statusInventoryItems,
  getInventoryItems,
}) {
  const [data, setData] = useState([])

  useEffect(() => {
    const availItems = inventoryItems.filter((ii) => ii.available_quantity > 0)
    setData(availItems)
    setAvailableItems(availItems)
  }, [inventoryItems])

  return (
    <div>
      {statusInventoryItems === API_STATUS.LOADING && <PageLoadingPanel />}

      {statusInventoryItems === API_STATUS.ERROR && <PageErrorPanel attemptReload={getInventoryItems} />}

      {statusInventoryItems === API_STATUS.SUCCESS &&
        (data.length ? (
          <>
            <LanzaTable
              className={"table table-bordered tbl_lanzatable table-hover"}
              columns={[
                {
                  Header: <FormattedMessage id="general.name" />,
                  accessor: "sku.name",
                  style: {
                    minWidth: "50px",
                  },
                },
                {
                  Header: <FormattedMessage id="general.description" />,
                  accessor: "sku.description",
                  style: {
                    minWidth: "50px",
                  },
                },
                {
                  Header: <FormattedMessage id="general.type" />,
                  accessor: "sku.inventory_type.name",
                  Filter: ({ column, preFilteredRows }) => (
                    <UniversalFilter
                      column={column}
                      setFilter={column.setFilter}
                      preFilteredRows={preFilteredRows}
                      filterType="select"
                      isClearable={false}
                      customOptions={inventoryTypes.map((t) => ({ value: t.name, text: t.name }))}
                    />
                  ),
                  style: {
                    minWidth: "100px",
                  },
                },
                {
                  Header: <FormattedMessage id="stock.lot" />,
                  accessor: "lot_no",
                  style: {
                    minWidth: "50px",
                  },
                },
                {
                  Header: <FormattedMessage id="stock.uom" />,
                  accessor: "uom",
                  style: {
                    minWidth: "50px",
                  },
                },
                {
                  Header: <FormattedMessage id="inventory.available_quantity" />,
                  accessor: "available_quantity",
                  style: {
                    minWidth: "50px",
                  },
                },
                {
                  Header: <FormattedMessage id="stock.retest_date" />,
                  accessor: "retest_date",
                  Cell: ({ value }) => {
                    return <LocaleFormattedDate date={value} shouldParse={true} showTime={false} />
                  },
                  style: {
                    minWidth: "50px",
                  },
                  disableFilters: true,
                },
                {
                  Header: <FormattedMessage id="inventory.last_received_date" />,
                  accessor: "last_received_date",
                  Cell: ({ value }) => {
                    return <LocaleFormattedDate date={value} shouldParse={true} />
                  },
                  style: {
                    minWidth: "50px",
                  },
                  disableFilters: true,
                },
              ]}
              data={data}
              allowSorting={true}
              allowFilters={true}
              initialTableOptions={{
                sortBy: [{ id: "last_received_date", desc: true }],
                pageSize: 10,
              }}
            />
          </>
        ) : (
          <div className={"center_middle"} style={{ height: "200px" }}>
            <div align={"center"}>
              <i className={"fa fa-info-circle"} style={{ fontSize: "45px" }} />
              <h4>
                <FormattedMessage id={"inventory.no-procurement-item-found"} />
              </h4>
            </div>
          </div>
        ))}
    </div>
  )
}

export default withInventoryConfig(InventoryItemsTable)
